import React, { FC, useState, useEffect } from 'react'
import { IonModal, IonHeader, IonContent, IonSpinner, IonToast } from '@ionic/react'
import { uuid } from '@dt/fe-utils'
import { loadingLayer } from '@utils'
import './index.scss'

interface IProps {
  serverUrl: string;
  hppJson: string;
  hideLoading?: boolean;
  resolve?: () => void;
  reject?: (error?: string) => void;
}

const GlobalPaymentsModal: FC<IProps> = ({ serverUrl, hppJson, hideLoading, resolve, reject }) => {
  const [globalPaymentsPayId, setGlobalPaymentsPayId] = useState('')
  const [loaded, setLoaded] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const [authorizing, setAuthorizing] = useState<boolean>(false)

  const handleFail = () => {
    reject(i18n.t('pay.failedMessage'))
  }

  const handleResult = async (result: any) => {
    setAuthorizing(true)
    try {
      if (result.RESULT === '00') {
        resolve()
      } else {
        reject(result.MESSAGE)
      }
    } catch (e) {
      setErrorMessage(e.message)
    } finally {
      setAuthorizing(false)
    }
  }

  const onLoaded = () => {
    setTimeout(() => {
      hideLoading && loadingLayer.hide()
      setLoaded(true)
    }, 1000)
  }

  const handleHppInit = (payParams: any, globalPaymentsPay: any) => {
    setTimeout(() => {
      window.RealexHpp?.setHppUrl(serverUrl)
      window.RealexHpp?.embedded?.init(
        'autoload',
        globalPaymentsPay,
        function (answer) {
          setTimeout(() => {
            handleResult(answer)
          }, 1000)
        },
        payParams
      )
    }, 500)
  }

  useEffect(() => {
    const _payParams = JSON.parse(hppJson)
    const _globalPaymentsPay = `globalPaymentsPay_${_payParams?.ORDER_ID || uuid}`
    setGlobalPaymentsPayId(_globalPaymentsPay)
    const rxpHppScript = document.getElementById('rxpHppScript')
    if (rxpHppScript) {
      handleHppInit(_payParams, _globalPaymentsPay)
    } else {
      const script = document.createElement('script')
      script.id = 'rxpHppScript'
      script.src = '/js/lib/globalpayments/rxp-hpp.js'
      script.onload = function () {
        handleHppInit(_payParams, _globalPaymentsPay)
      }
      document.body.appendChild(script)
    }
  }, [])

  return (
    <IonModal
      isOpen
      cssClass='global-payments-modal'
      onDidDismiss={handleFail}
    >
      <IonHeader>
        <div className='global-payments-header'>
          {i18n.t('pay.onlinePay')}
          <i className='iconfont icon-close' data-cypid='globalPaymentsModalFail' onClick={handleFail} />
        </div>
      </IonHeader>
      <IonToast
        position='top'
        color='danger'
        isOpen={!!errorMessage}
        onDidDismiss={() => setErrorMessage('')}
        message={errorMessage}
        duration={2000}
      />
      <IonContent className='global-payments-content'>
        {!loaded && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.jumpTogGlobalPaymentsPage')}</div>
          </div>
        )}
        {authorizing && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.jumpingToPay')}</div>
          </div>
        )}
        <iframe
          id={globalPaymentsPayId}
          name={globalPaymentsPayId}
          frameBorder='0'
          scrolling='no'
          onLoad={onLoaded}
        />
      </IonContent>
    </IonModal>
  )
}

export default GlobalPaymentsModal
